import React, { useState } from 'react'
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useTranslation } from '@/hooks'
import { userStore } from '@/stores'

const AccountTab: React.FC = () => {
  const { t } = useTranslation()
  const { user } = userStore
  console.log(user)
  const [formData, setFormData] = useState({
    firstName: user?.firstName,
    lastName: user?.lastName,
    email: user?.email,
    organization: 'Acme Inc.',
  })

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }))
  }

  const handleSave = () => {
    // Save account information
    console.log('Saving account information:', formData)
  }

  return (
    <Card className="border-none p-0 shadow-none mt-4">
      <CardHeader className="p-0 mb-6">
        <CardTitle className="text-2xl font-bold text-gray-800">{t('settings.account.personal_info')}</CardTitle>
        <CardDescription className="text-gray-600 mt-2">{t('settings.account.update_details')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6 p-0">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          <div className="space-y-3">
            <Label htmlFor="firstName" className="text-sm font-semibold text-gray-700">
              {t('settings.account.first_name')}
            </Label>
            <Input
              disabled
              id="firstName"
              placeholder={t('settings.account.enter_first_name')}
              value={formData.firstName}
              onChange={handleInputChange}
              className="border-gray-200 bg-gray-50 focus:ring-primary focus:border-primary rounded-lg h-12 font-medium shadow-sm"
            />
          </div>
          <div className="space-y-3">
            <Label htmlFor="lastName" className="text-sm font-semibold text-gray-700">
              {t('settings.account.last_name')}
            </Label>
            <Input
              disabled
              id="lastName"
              placeholder={t('settings.account.enter_last_name')}
              value={formData.lastName}
              onChange={handleInputChange}
              className="border-gray-200 bg-gray-50 focus:ring-primary focus:border-primary rounded-lg h-12 font-medium shadow-sm"
            />
          </div>
        </div>
        <div className="space-y-3">
          <Label htmlFor="email" className="text-sm font-semibold text-gray-700">
            {t('settings.account.email')}
          </Label>
          <Input
            disabled
            id="email"
            type="email"
            placeholder={t('settings.account.enter_email')}
            value={formData.email}
            onChange={handleInputChange}
            className="border-gray-200 bg-gray-50 focus:ring-primary focus:border-primary rounded-lg h-12 font-medium shadow-sm"
          />
        </div>
        <div className="space-y-3">
          <Label htmlFor="organizationId" className="text-sm font-semibold text-gray-700">
            Organization ID
          </Label>
          <Input
            disabled
            id="organizationId"
            type="text"
            value={user?.organization_id || 'N/A'}
            className="border-gray-200 bg-gray-50 focus:ring-primary focus:border-primary rounded-lg h-12 font-medium shadow-sm"
          />
        </div>
        {/* <div className="space-y-2">
          <Label htmlFor="organization">
            {t('settings.account.organization')}
          </Label>
          <Input
            disabled
            id="organization"
            placeholder={t('settings.account.enter_organization')}
            value={formData.organization}
            onChange={handleInputChange}
            className="border-gray-300 focus:ring-teal-500 focus:border-teal-500"
          />
        </div> */}
      </CardContent>
      <CardFooter className="pt-6">
        <Button
          disabled
          onClick={handleSave}
          className="bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70 text-white font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 h-12 px-8 rounded-xl"
        >
          {t('settings.account.save_changes')}
        </Button>
      </CardFooter>
    </Card>
  )
}

export default AccountTab
